import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'jiko-hyoka-mikouhyou-gensan',
    title: '自己評価結果等未公表減算｜年1回の公表と都道府県への届出',
    description:
        '自己評価結果等未公表減算は所定単位数の85/100、障害児全員が対象です。指定通所基準 第26条第7項が求めるおおむね1年に1回以上の公表と、都道府県への届出。同じ15%減の支援プログラム未公表減算とは要件も頻度も別制度です。公表文の文例つきで整理しました。',
    excerpt:
        '集計表を貼って終わりにしていませんか。国の事務連絡は、集計結果の公表が趣旨ではないと書いています。求められているのは分析と改善の取組です。',
    category: '運営指導',
    keywords: [
        '自己評価結果等未公表減算',
        '自己評価 未公表 減算',
        '自己評価結果 公表 届出',
        '保護者評価 アンケート 頻度',
        '自己評価 15%減'
    ],
    publishedAt: '2026-06-16',
    updatedAt: '2026-06-16',
};
